import React from "react";
import "./PFHBanner.css";

interface PFHBannerProps {
  remoteConfig: {
    enabled: boolean;
    image_url: string;
    cta_url: string;
    video_url?: string;
    cta_text?: string;
  } | null;
  onImageClick: () => void;
}

const PFHBanner: React.FC<PFHBannerProps> = ({
  remoteConfig,
  onImageClick,
}) => {
  // Always call hooks at the top
  const [isVideoMuted, setIsVideoMuted] = React.useState(true);
  const videoRef = React.useRef<HTMLVideoElement>(null);

  if (!remoteConfig?.enabled) {
    return null;
  }

  // Prefer video if available
  const hasVideo = (remoteConfig as any).video_url;
  const ctaText = (remoteConfig as any).cta_text || "Explore";

  return (
    <div className="pfh-banner-container" style={{ position: "relative" }}>
      {hasVideo ? (
        <button
          onClick={onImageClick}
          style={{
            width: "100%",
            padding: 0,
            border: "none",
            background: "none",
            cursor: "pointer",
            position: "relative",
            display: "block",
            borderRadius: 8,
            overflow: "hidden",
          }}
        >
          <video
            ref={videoRef}
            src={(remoteConfig as any).video_url}
            className="pfh-banner-image"
            style={{ width: "100%", height: "auto", display: "block" }}
            autoPlay
            muted={isVideoMuted}
            loop
            playsInline
          ></video>
          <span
            style={{
              display: "block",
              width: "100%",
              background: "rgba(36, 108, 193, 1)",
              color: "#fff",
              fontWeight: 600,
              fontSize: 18,
              padding: "16px 0",
              textAlign: "center",

              borderBottomLeftRadius: 8,
              borderBottomRightRadius: 8,
            }}
          >
            {ctaText}
          </span>
          {/* Mute/Unmute button overlay */}
          <span
            style={{
              position: "absolute",
              top: 12,
              right: 12,
              zIndex: 3,
              background: "rgba(0,0,0,0.5)",
              borderRadius: "50%",
              width: 40,
              height: 40,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            onClick={(e) => {
              e.stopPropagation();
              setIsVideoMuted((m) => !m);
            }}
          >
            {isVideoMuted ? (
              <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
                <path d="M4 9v6h4l5 5V4L8 9H4zm13.5 3c0-1.77-.77-3.29-2-4.29v8.58c1.23-1 2-2.52 2-4.29z" />
              </svg>
            ) : (
              <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
                <path d="M16.5 12c0-1.77-.77-3.29-2-4.29v8.58c1.23-1 2-2.52 2-4.29zm3.5 0c0 2.53-1.17 4.77-3 6.18v-2.06c1.19-1.02 2-2.54 2-4.12s-.81-3.1-2-4.12V5.82c1.83 1.41 3 3.65 3 6.18zM4 9v6h4l5 5V4L8 9H4z" />
              </svg>
            )}
          </span>
        </button>
      ) : (
        <img
          src={remoteConfig.image_url}
          alt="PFH Banner"
          className="pfh-banner-image"
          style={{ width: "100%", height: "auto", display: "block" }}
        />
      )}
    </div>
  );
};

export default PFHBanner;
